import IBaseListingResponse from "../../../utils/api/base-listing-response";
import {
  IBatchWriteOff,
  IBatchWriteOffBatch,
  IBatchWriteOffOrder,
  IBatchWriteOffProduct,
  IBatchWriteOffProductOrder,
  IBatchWriteOffStore,
  IEnumResource,
  IUserLight,
} from "./response";

const unwrapApiResource = (response: any) =>
  response?.success !== undefined && response?.data !== undefined
    ? response.data
    : response;

const mapEnumResource = (item: any): IEnumResource | null => {
  if (!item) return null;
  return {
    value: item.value,
    name: item.name ?? null,
  };
};

const mapUserLight = (item: any): IUserLight | null => {
  if (!item) return null;
  return {
    id: item.id,
    firstName: item.first_name ?? item.firstName ?? null,
    lastName: item.last_name ?? item.lastName ?? null,
    fullName: item.full_name ?? item.fullName ?? null,
    mobile: item.mobile ?? null,
    cleanMobile: item.clean_mobile ?? item.cleanMobile ?? null,
  };
};

const mapBatch = (item: any): IBatchWriteOffBatch | null => {
  if (!item) return null;
  return {
    id: item.id,
    batchNumber: item.batch_number ?? item.batchNumber ?? null,
    productId: item.product_id ?? item.productId ?? null,
    storeId: item.store_id ?? item.storeId ?? null,
    enteredQuantity: item.entered_quantity ?? item.enteredQuantity ?? null,
    withdrawnQuantity:
      item.withdrawn_quantity ?? item.withdrawnQuantity ?? null,
    availableQuantity:
      item.available_quantity ?? item.availableQuantity ?? null,
    expirationDate: item.expiration_date ?? item.expirationDate ?? null,
    purchaseDate: item.purchase_date ?? item.purchaseDate,
  };
};

const mapOrder = (item: any): IBatchWriteOffOrder | null => {
  if (!item) return null;
  return {
    id: item.id,
    number: item.number ?? null,
    status: mapEnumResource(item.status),
    currentStoreId: item.current_store_id ?? item.currentStoreId ?? null,
    selectedStoreId: item.selected_store_id ?? item.selectedStoreId ?? null,
  };
};

const mapProductOrder = (item: any): IBatchWriteOffProductOrder | null => {
  if (!item) return null;
  return {
    id: item.id,
    orderId: item.order_id ?? item.orderId ?? null,
    productId: item.product_id ?? item.productId ?? null,
    storeId: item.store_id ?? item.storeId ?? null,
    count: item.count ?? null,
    reservedCount: item.reserved_count ?? item.reservedCount ?? null,
    isAvailable: item.is_available ?? item.isAvailable ?? null,
    isAccepted: item.is_accepted ?? item.isAccepted ?? null,
    note: item.note ?? null,
  };
};

const mapProduct = (item: any): IBatchWriteOffProduct | null => {
  if (!item) return null;
  return {
    id: item.id,
    name: item.name ?? null,
    barcode: item.barcode ?? null,
  };
};

const mapStore = (item: any): IBatchWriteOffStore | null => {
  if (!item) return null;
  return {
    id: item.id,
    name: item.name ?? null,
  };
};

export const mapBatchWriteOff = (item: any): IBatchWriteOff => ({
  id: item.id,
  batchId: item.batch_id ?? item.batchId ?? null,
  batch: mapBatch(item.batch),
  quantity: Number(item.quantity ?? 0),
  reason: mapEnumResource(item.reason),
  source: mapEnumResource(item.source),
  status: mapEnumResource(item.status),
  systemInitiated: item.system_initiated ?? item.systemInitiated ?? false,
  orderId: item.order_id ?? item.orderId ?? null,
  order: mapOrder(item.order),
  productOrderId: item.product_order_id ?? item.productOrderId ?? null,
  productOrder: mapProductOrder(item.product_order ?? item.productOrder),
  productId: item.product_id ?? item.productId ?? null,
  product: mapProduct(item.product),
  storeId: item.store_id ?? item.storeId ?? null,
  store: mapStore(item.store),
  notes: item.notes ?? null,
  createdAt: item.created_at ?? item.createdAt ?? null,
  createdBy: mapUserLight(item.created_by ?? item.createdBy),
  initiatedBy: mapUserLight(item.initiated_by ?? item.initiatedBy),
  confirmedBy: mapUserLight(item.confirmed_by ?? item.confirmedBy),
  confirmedAt: item.confirmed_at ?? item.confirmedAt ?? null,
  confirmationNotes: item.confirmation_notes ?? item.confirmationNotes ?? null,
  reversedBy: mapUserLight(item.reversed_by ?? item.reversedBy),
  reversedAt: item.reversed_at ?? item.reversedAt ?? null,
  reversalNotes: item.reversal_notes ?? item.reversalNotes ?? null,
  canConfirm: item.can_confirm ?? item.canConfirm ?? false,
  canReverse: item.can_reverse ?? item.canReverse ?? false,
});

export const normalizeBatchWriteOffListingResponse = (
  response: any,
): IBaseListingResponse<IBatchWriteOff> => {
  const payload = unwrapApiResource(response);
  const rows = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload)
      ? payload
      : [];

  return {
    ...payload,
    data: rows.map(mapBatchWriteOff),
    total:
      payload?.total ??
      payload?.totalCount ??
      payload?.meta?.total ??
      rows.length,
  };
};
